import { Form, Flex } from 'antd';
import { TextInput } from '~/app/components/common/TextInput';
import { Button } from '~/app/components/common/Button/';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

type SecurityFormProps = {
  showOld: boolean;
  setShowOld: (show: boolean) => void;
  t: (key: string) => string;
  showNew: boolean;
  setShowNew: (show: boolean) => void;
  passwordError: { currentPassword?: string; newPassword?: string };
  passwordValues: { currentPassword: string; newPassword: string };
  setPasswordValues: (v: {
    currentPassword: string;
    newPassword: string;
  }) => void;
  isPasswordFormDisabled: boolean;
  handlePasswordFinish: (currentPassword: string, newPassword: string) => void;
};

export const SecurityForm: React.FC<SecurityFormProps> = ({
  showOld,
  setShowOld,
  t,
  showNew,
  setShowNew,
  passwordError,
  passwordValues,
  setPasswordValues,
  isPasswordFormDisabled,
  handlePasswordFinish,
}) => (
  <Form
    layout="vertical"
    className="app-max-width-700 app-full-width"
    onFinish={({ currentPassword, newPassword }) =>
      handlePasswordFinish(currentPassword, newPassword)
    }
  >
    <Flex gap={16}>
      <Form.Item
        label="Current Password"
        name="currentPassword"
        className="app-flex-1"
        validateStatus={passwordError.currentPassword ? 'error' : ''}
        help={passwordError.currentPassword}
      >
        <TextInput
          type={showOld ? 'text' : 'password'}
          autoComplete="off"
          size="middle"
          value={passwordValues.currentPassword}
          onChange={(e) =>
            setPasswordValues({
              ...passwordValues,
              currentPassword: e.target.value,
            })
          }
          suffix={
            showOld ? (
              <EyeTwoTone onClick={() => setShowOld(false)} />
            ) : (
              <EyeInvisibleOutlined onClick={() => setShowOld(true)} />
            )
          }
        />
      </Form.Item>
      <Form.Item
        label="New Password"
        name="newPassword"
        className="app-flex-1"
        validateStatus={passwordError.newPassword ? 'error' : ''}
        help={passwordError.newPassword}
      >
        <TextInput
          type={showNew ? 'text' : 'password'}
          autoComplete="off"
          size="middle"
          value={passwordValues.newPassword}
          onChange={(e) =>
            setPasswordValues({
              ...passwordValues,
              newPassword: e.target.value,
            })
          }
          suffix={
            showNew ? (
              <EyeTwoTone onClick={() => setShowNew(false)} />
            ) : (
              <EyeInvisibleOutlined onClick={() => setShowNew(true)} />
            )
          }
        />
      </Form.Item>
    </Flex>
    <Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        rounded
        disabled={isPasswordFormDisabled}
      >
        {t('common:buttons.save')}
      </Button>
    </Form.Item>
  </Form>
);
